import styled from 'styled-components';

import React, { useState } from 'react';
import idGenerator from 'react-id-generator';

export interface ToggleProps {
  input: {
    onChange: (value: boolean) => void;
    value: boolean;
  };
  disabled?: boolean;
  label?: string;
  name?: string;
}

const AdditionalInfo = styled.span`
  font-size: 90%;
  opacity: 0.7;
  margin-top: 1em;
  display: block;
`;

export const Toggle: React.FC<ToggleProps> = ({ input, disabled = false, label, name }) => {
  const [id] = useState(idGenerator());

  return (
    <ToggleInput>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={input.value}
        onChange={({ target }) => input.onChange(target.checked)}
        disabled={disabled}
        aria-label="toggle-input"
      />
      <label htmlFor={id} className="toggle">
        <span className="toggle-handle" />
      </label>
      <label htmlFor={id}>
        <AdditionalInfoWrapper>{label}</AdditionalInfoWrapper>
      </label>
    </ToggleInput>
  );
};

const AdditionalInfoWrapper = styled(AdditionalInfo)`
  opacity: 1;
  margin-top: 0;
`;

const ToggleInput = styled.div`
  display: flex;
  align-items: center;

  input {
    display: none;
  }

  .toggle {
    position: relative;
    display: block;
    width: 40px;
    height: 20px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transform: translate3d(0, 0, 0);
    margin-right: 10px;
  }
  .toggle:before {
    content: '';
    position: relative;
    top: 3px;
    left: 3px;
    width: 34px;
    height: 14px;
    display: block;
    background: ${(props) => props.theme.greyColors['grey-10']};
    border-radius: 8px;
    transition: background 0.2s ease;
  }
  .toggle .toggle-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    display: block;
    background: white;
    border-radius: 10px;
    box-shadow: 0 3px 8px rgba(154, 153, 153, 0.5);
    transition: all 0.2s ease;
  }
  .toggle .toggle-handle:before {
    content: '';
    position: absolute;
    display: block;
    margin: -18px;
    width: 56px;
    height: 56px;
    background: rgba(79, 46, 220, 0.5);
    border-radius: 50%;
    transform: scale(0);
    opacity: 1;
    pointer-events: none;
  }

  input:checked + .toggle:before {
    background: ${(props) => props.theme.primaryColour};
  }
  input:checked + .toggle .toggle-handle {
    transform: translateX(20px);
    transition: all 0.2s cubic-bezier(0.8, 0.4, 0.3, 1.25), background 0.15s ease;
    box-shadow: 0 3px 8px rgba(79, 46, 220, 0.2);
  }
  input:checked + .toggle .toggle-handle:before {
    transform: scale(1);
    opacity: 0;
    transition: all 0.4s ease;
  }
`;
